<template>
  <div class="navigation-container">
    <nav class="main-nav">
      <div class="nav-brand">
        <h1>股票分析系统</h1>
      </div>
      
      <div class="nav-links">
        <router-link 
          to="/monitor" 
          class="nav-link" 
          active-class="active"
        >
          <span class="nav-icon">📊</span>
          <span class="nav-text">股票监控</span>
        </router-link>
        
        <router-link 
          to="/health-check" 
          class="nav-link" 
          active-class="active"
        >
          <span class="nav-icon">🔍</span>
          <span class="nav-text">股票体检</span>
        </router-link>
        
        <div class="nav-dropdown">
          <router-link 
            to="/choose" 
            class="nav-link dropdown-toggle" 
            active-class="active"
          >
            <span class="nav-icon">⭐</span>
            <span class="nav-text">选股</span>
          </router-link>
          <div class="dropdown-menu">
            <router-link 
              to="/single-stock-holder" 
              class="dropdown-item"
            >
              股票股东数
            </router-link>
            <router-link 
              to="/multiple-stock-score" 
              class="dropdown-item"
            >
              多股票股东数
            </router-link>
            <router-link 
              to="/industry-plate-holders" 
              class="dropdown-item"
            >
              行业板块股东数
            </router-link>
          </div>
        </div>
      </div>
      
      <div class="nav-actions">
        <router-link 
          to="/settings" 
          class="settings-link"
        >
          ⚙️
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Navigation'
};
</script>

<style scoped>
.navigation-container {
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.main-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-brand h1 {
  margin: 0;
  font-size: 1.5em;
  color: #2c3e50;
  font-weight: 600;
}

.nav-links {
  display: flex;
  gap: 5px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  text-decoration: none;
  color: #666;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover {
  background-color: #f8f9fa;
  color: #2c3e50;
}

.nav-link.active {
  background-color: #42b983;
  color: white;
  box-shadow: 0 2px 8px rgba(66, 185, 131, 0.3);
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background-color: #42b983;
  border-radius: 2px;
}

.nav-icon {
  font-size: 1.2em;
}

.nav-text {
  font-weight: 500;
  font-size: 1em;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.settings-link {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  text-decoration: none;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 6px;
  transition: all 0.3s ease;
  background: white;
}

.settings-link:hover {
  background-color: #f8f9fa;
  color: #2c3e50;
  border-color: #bbb;
}

/* 下拉菜单样式 */
.nav-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  min-width: 160px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
  border-radius: 6px;
  z-index: 1000;
  padding: 5px 0;
}

.nav-dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-item {
  display: block;
  padding: 12px 20px;
  text-decoration: none;
  color: #666;
  transition: all 0.3s ease;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  color: #2c3e50;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-nav {
    height: auto;
    padding: 15px 10px;
    flex-direction: column;
    gap: 15px;
  }
  
  .nav-brand h1 {
    font-size: 1.2em;
  }
  
  .nav-links {
    width: 100%;
    justify-content: space-around;
    gap: 2px;
  }
  
  .nav-link {
    flex: 1;
    justify-content: center;
    padding: 10px 8px;
    font-size: 0.9em;
  }
  
  .nav-text {
    display: none; /* 在移动端隐藏文字，只显示图标 */
  }
  
  .nav-actions {
    align-self: flex-end;
  }
  
  .settings-link {
    padding: 6px 12px;
    font-size: 0.9em;
  }
  
  /* 移动端下拉菜单 */
  .nav-dropdown:hover .dropdown-menu {
    display: none;
  }
  
  .dropdown-menu {
    position: static;
    box-shadow: none;
    background: transparent;
    padding: 0;
  }
  
  .dropdown-item {
    padding: 8px 15px;
    font-size: 0.9em;
  }
}

@media (max-width: 480px) {
  .main-nav {
    padding: 10px 5px;
  }
  
  .nav-links {
    gap: 1px;
  }
  
  .nav-link {
    padding: 8px 4px;
  }
  
  .nav-icon {
    font-size: 1em;
  }
}</style>